export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe891e2d1012e2cbd651bc98887d94d1298f5955f&name=fetchTypeahead!'